@if (dataCategories?.length > 0) {
  <sd-component-wrapper [content]="categoriesWrapper" [themesConfig]="backgroundTheme">
    <sd-subcategories sd-component-wrapper-component
      [subcategories]="dataCategories"
      [linkCardSubcategories]="false"
      (subCatClicked)="onClickSubCat($event)"
    />
  </sd-component-wrapper>
}
